import React, { useState } from 'react';

const ProductContext = React.createContext();

const ProductProvider = (props) => {
  const [product, setProduct] = useState(props.value)

  return (
    <ProductContext.Provider value={[product, setProduct]}>
      {props.children}
    </ProductContext.Provider>
  );
};

export { ProductContext, ProductProvider}
